import { render } from "./ClientDbMaintenance.vue?vue&type=template&id=2d9ebbe2&scoped=true"
import script from "./ClientDbMaintenance.vue?vue&type=script&lang=js"
export * from "./ClientDbMaintenance.vue?vue&type=script&lang=js"

import "./ClientDbMaintenance.vue?vue&type=style&index=0&id=2d9ebbe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9ebbe2"]])

export default __exports__